// extracted by mini-css-extract-plugin
module.exports = {"main":"layout-module--main--16H54","footer":"layout-module--footer--Qriki"};